import { BaseQuestionnaireRoute } from '../slice';

export type PassiveIncomeSubRoutes = {
  dividends: BaseQuestionnaireRoute;
  interest: BaseQuestionnaireRoute;
  pension: BaseQuestionnaireRoute;
  rentalIncome: BaseQuestionnaireRoute;
};

export type PassiveIncomeRoutes = BaseQuestionnaireRoute &
  PassiveIncomeSubRoutes;

export const passiveIncomeRoutes: { passiveIncome: PassiveIncomeRoutes } = {
  passiveIncome: {
    title: 'Passive Income',
    path: 'passiveIncome',
    isValid: undefined,
    toggle: false,
    dividends: {
      title: 'Dividends',
      path: 'dividends',
      isValid: undefined,
    },
    interest: {
      title: 'Interest',
      path: 'interest',
      isValid: undefined,
    },
    pension: {
      title: 'Pension',
      path: 'pension',
      isValid: undefined,
    },
    rentalIncome: {
      title: 'Rental Income',
      path: 'rentalIncome',
      isValid: undefined,
    },
  },
};
